<template>
  <TransitionWithText :text="this.transitionText" :fast="true">
    <div class="page-content">
      <div class="title">Next Steps: </div>

      <ul class="steps">
        <li>
          <span class="step-number">1. </span><span class="step-content">Find out your prize, which we are calculating now (coming up in less than a minute).</span>
        </li>
        <li>
          <span class="step-number">2. </span><span class="step-content">Start your challenge whenever you'd like by weighing in on our mobile app. It's fun and takes about 30 seconds.</span>
        </li>
        <li>
          <span class="step-number">3. </span><span class="step-content">Use the tools on our awesome mobile app to lose weight.</span>
        </li>
        <li>
          <span class="step-number">4. </span><span class="step-content">Win your challenge and get paid quickly via check or PayPal.</span>
        </li>
      </ul>
    </div>

    <div class="footer-container">
      <ButtonNext :onClick="next" :isDisabled="false" :text="'Next'" />
      <ProgressBar />
    </div>
  </TransitionWithText>
</template>

<script>
import TransitionWithText from '../../shared/components/TransitionWithText';
import ButtonNext from '../../shared/components/ButtonNext';
import ProgressBar from '../../shared/components/ProgressBar';
import { delayedTransition, ROUTE_NAMES } from '../router';
import Trackeable from '../../Trackeable';
import ProgressFull from '../mixins/ProgressFull';

export default {
  components: {
    TransitionWithText,
    ButtonNext,
    ProgressBar
  },
  mixins: [Trackeable, ProgressFull],
  data() {
    return {
      transitionText: "Let's talk about how this works..."
    }
  },
  methods: {
    next() {
      delayedTransition(this.$router, ROUTE_NAMES.PaidOut)
    }
  }
}
</script>
